/* eslint-disable */

import UseService from "../UseServices";

const CombinadasService = {
    async getCombinadas(data) {
        var resp = await UseService.post("combinadas/list", data);
        return resp;
    },
};
export default CombinadasService;